import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState(['countries'])
    },
    
    mounted() {
        if(!this.countries.length) {
            this.$store.dispatch('fetchCountries');
        }
    }

}